class FaqAccordion {
	constructor(dom) {
		this.dom = dom;
	}

	init() {
		this.dom.querySelectorAll('.faqs__item-btn').forEach(btn => {
			btn.addEventListener('click', () => {
				const item = btn.closest('.faqs__item');
				const isOpen = item.classList.contains('is-open');

				this._closeAll();

				if (!isOpen) {
					this._open(item);
				}
			});
		});
	}

	_open(item) {
		const answer = item.querySelector('.faqs__item-answer');
		if (!answer) return;
		item.classList.add('is-open');
		item.querySelector('.faqs__item-btn').setAttribute('aria-expanded', 'true');
		answer.setAttribute('aria-hidden', 'false');
		answer.style.height = answer.scrollHeight + 'px';
	}

	_closeAll() {
		this.dom.querySelectorAll('.faqs__item.is-open').forEach(item => {
			const answer = item.querySelector('.faqs__item-answer');
			item.classList.remove('is-open');
			item.querySelector('.faqs__item-btn').setAttribute('aria-expanded', 'false');
			if (answer) {
				answer.style.height = '0';
				answer.setAttribute('aria-hidden', 'true');
			}
		});
	}
}

export default FaqAccordion;
